import React, { useState, useContext } from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";

// Styles
import { Layout, Row, Avatar } from "antd";
import { Main, ImgFooter, Title } from "./styles";

// Menu
import Menu from "../components/menu/newMenu";

// Pages
import Articulo from "./../pages/articulo";
import ListArticles from "./../pages/list-articles";
import DesignProcess from "./../pages/design-process";
import ListDesignProcess from "./../pages/list-design-process";
import ManufacturingOrder from "./../pages/manufacturing-order";
import ControlProcess from "./../pages/control-process";
import Historical from "./../pages/historical";

//Components
import SelectLanguage from "./../components/select-language";

//image
import ceit from "../assets/img/ceit.png";

//import multilanguage library
import { useTranslation } from 'react-i18next'

import { AuthContext } from "../App";

// Layout
const { Header, Content, Footer } = Layout;

const Routes = props => {
  const [title, setTitle] = useState("");

  
  const { t } = useTranslation();

  const newTitle = (ti, value) => setTitle(t('title.'+ti, { name: value }));

  const { state } = useContext(AuthContext);
  
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Layout style={{ minHeight: "100vh" }}>
        <Menu Link={Link} />

        <Layout>
          <Header style={{ padding: 0, backgroundColor: "white" }}>
            <Row type="flex" justify="space-between" gutter={12}>
              <Title>{title}</Title>
              <span>
                <SelectLanguage />
                {/*<ImgHeader src={ceit} alt="CEIT" />*/}
                <Avatar style={{ backgroundColor: state.user && state.user.avatar_color ? state.user.avatar_color : "#ccc"  , verticalAlign: 'middle', margin: "0px 21px", marginBottom: "3px" }} size="large">
                  {state.user && state.user.avatar_name ? state.user.avatar_name : "User"}
                </Avatar>
              </span>
            </Row>
          </Header>
          <Content style={{ margin: "8px 16px" }}>
            <Main>
              <Switch>
                <Route path="/add" exact>
                  <Articulo changeTitle={newTitle} />
                </Route>
                <Route path="/" exact>
                  <ListArticles changeTitle={newTitle} />
                </Route>

                <Route path="/design-process" exact>
                  <DesignProcess changeTitle={newTitle} />
                </Route>

                <Route path="/list-design-process" exact>
                  <ListDesignProcess changeTitle={newTitle} />
                </Route>
                
                <Route path="/manufacturing-order" exact>
                  <ManufacturingOrder changeTitle={newTitle} />
                </Route>

                <Route path="/control-process" exact>
                  <ControlProcess changeTitle={newTitle} />
                </Route>
                
                <Route path="/historical" exact>
                  <Historical changeTitle={newTitle} />
                </Route>
              </Switch>
            </Main>
          </Content>
          <Footer style={{ textAlign: "center", padding: 3, minHeight: 48, marginTop: 10, marginBottom: 5 }}><ImgFooter src={ceit} alt="CEIT" /> <span style={{verticalAlign: "sub"}}>&#9400;2020</span> </Footer>
        </Layout>
      </Layout>
    </Router>
  );
};

export default Routes;
